"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _LogService = require("../KESI2/Services/LogService");

var _PromiseHelper = require("../utils/PromiseHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var DEFAULT_TRACKING_INTERVAL_DURATION = 5 * 60 * 1000; // 5 min

var trackingInterval = null;

var DeviceTracking = /*#__PURE__*/function () {
  function DeviceTracking() {
    (0, _classCallCheck2["default"])(this, DeviceTracking);
  }

  (0, _createClass2["default"])(DeviceTracking, null, [{
    key: "getTrackingValues",
    value: function () {
      var _getTrackingValues = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(trackLocation) {
        var trackingValues, hostName;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                trackingValues = {}; // app id

                _context.next = 3;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 3:
                trackingValues.applicationInstanceId = _context.sent;

                // miscellaneous
                if (window.BuildInfo) {
                  trackingValues.bundleId = window.BuildInfo.packageName;
                  trackingValues.debug = window.BuildInfo.debug;
                  trackingValues.displayName = window.BuildInfo.displayName;
                  trackingValues.buildDate = window.BuildInfo.buildDate ? window.BuildInfo.buildDate.toJSON() : null;
                  trackingValues.installData = window.BuildInfo.installDate ? window.BuildInfo.installDate.toJSON() : null;
                  trackingValues.version = window.BuildInfo.version;
                  trackingValues.versionCode = window.BuildInfo.versionCode;
                }

                hostName = _DeviceInfoHelper["default"].isBrowser() ? window.location.href : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.EQUEO_HOST_NAME);

                if (hostName) {
                  trackingValues.hostName = hostName;
                } // system information


                trackingValues.system = {};
                trackingValues.system.language = window.navigator.language;

                if (window.device) {
                  trackingValues.system.os = window.device.platform;
                  trackingValues.system.version = window.device.version;
                  trackingValues.system.model = window.device.model;
                  trackingValues.system.manufacturer = window.device.manufacturer;
                } // internet connection
                // trackingValues.connection = window.navigator.connection.type
                // display size


                trackingValues.display = {
                  width: window.screen.width,
                  height: window.screen.height
                }; // location

                if (trackLocation && window.navigator.geolocation.SafetureLocation) {
                  trackingValues.location = {};
                  trackingValues.location.lng = window.navigator.geolocation.SafetureLocation.longitude;
                  trackingValues.location.lat = window.navigator.geolocation.SafetureLocation.latitude;
                } // no appsflyer id for now as appslfyer is unused anyway


                if (!(window.plugins && window.plugins.appsFlyer && window.plugins.appsFlyer.getAppsFlyerUID)) {
                  _context.next = 21;
                  break;
                }

                _context.prev = 13;
                _context.next = 16;
                return (0, _PromiseHelper.timeoutPromise)(new _promise["default"](function (resolve, reject) {
                  window.plugins.appsFlyer.getAppsFlyerUID(function (id) {
                    trackingValues.appsflyerId = id;
                    resolve(trackingValues);
                  });
                }));

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](13);
                return _context.abrupt("return", trackingValues);

              case 21:
                return _context.abrupt("return", trackingValues);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[13, 18]]);
      }));

      function getTrackingValues(_x) {
        return _getTrackingValues.apply(this, arguments);
      }

      return getTrackingValues;
    }()
  }, {
    key: "saveTrackingValuesToDataStore",
    value: function () {
      var _saveTrackingValuesToDataStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var sendToServer,
            trackingValues,
            updateValue,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sendToServer = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
                _context2.next = 3;
                return DeviceTracking.getTrackingValues(!sendToServer);

              case 3:
                trackingValues = _context2.sent;
                console.log('collected tracking information', (0, _stringify["default"])(trackingValues));

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TRACKING_DATA, trackingValues);

                updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);

                return _context2.abrupt("return", trackingValues);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function saveTrackingValuesToDataStore() {
        return _saveTrackingValuesToDataStore.apply(this, arguments);
      }

      return saveTrackingValuesToDataStore;
    }()
  }, {
    key: "trackNow",
    value: function () {
      var _trackNow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var trackingValues;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return DeviceTracking.saveTrackingValuesToDataStore(true);

              case 2:
                trackingValues = _context3.sent;
                // as the values typically do not change it is fair enough to send them to server whenever the app starts
                // this also happens on OS and app upgrade
                (0, _LogService.pushGenericLogMessage)({
                  type: 'deviceTracking',
                  values: trackingValues
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function trackNow() {
        return _trackNow.apply(this, arguments);
      }

      return trackNow;
    }()
  }, {
    key: "startTracking",
    value: function () {
      var _startTracking = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.trackNow(); // store up to date information every now and then (location can changes)

                trackingInterval = setInterval(DeviceTracking.saveTrackingValuesToDataStore, DEFAULT_TRACKING_INTERVAL_DURATION);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function startTracking() {
        return _startTracking.apply(this, arguments);
      }

      return startTracking;
    }()
  }, {
    key: "stopTracking",
    value: function stopTracking() {
      clearInterval(trackingInterval);
    }
  }]);
  return DeviceTracking;
}();

var _default = DeviceTracking;
exports["default"] = _default;